import { createContext } from 'react';

const MobileThemeContext = /*#__PURE__*/createContext(undefined);

export { MobileThemeContext as M };
//# sourceMappingURL=MobileThemeContext-ILBGocWR.js.map
